import tabs from './modules/tabs';
import sliders from './modules/sliders';

$(document).ready(function() {
    sliders();

    tabs('.products__tab', '.products__container', '.products__tabs', null, null, 'show-flex');
    tabs('.courier__tabs-content', '[data-tabcontent="courier"]', '.courier__tabs', 'courier__tabs-content_active');

    const conceptionImgPaths = ["icons/conception-page/conception.svg",
        "icons/conception-page/conception02.svg",
        "icons/conception-page/conception03.svg"
    ];

    tabs(".conception__tab", "[data-complex='tab']", ".conception__tabs", "conception__tab--active", conceptionImgPaths);

    // Jquery zone

    $('.rules__item-title').on('click', function() {
        $(this).next().slideToggle();
        $(this).toggleClass('rules__item-title_active');
    });

    //burger-menu
    $('.hamburger').on('click', function() {
        $('.mobile__menu').toggleClass('mobile__menu-active');
    });

    //анимация бургера
    $('.hamburger').on('click', function() {
        $('.hamburger').toggleClass('hamburger_active');
    });

    $('.products__dropdown').on('click', function() {
        $(this).next().slideToggle();
        $(this).toggleClass('products__dropdown-active');
    });
    //scroll
    $('.main__arrow').on('click', function(e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top
        }, 500, 'linear');
    });

    function slideMenuItems(selector) {
        $(`${selector}:eq(0)`).on('click', () => {
            if ($(`${selector}:eq(0)`).hasClass('opened')) {
                $(`${selector}:gt(0)`).fadeOut();
                $(`${selector}:eq(0)`).removeClass('opened');
            } else {
                $(`${selector}:gt(0)`).fadeIn();
                $(`${selector}:eq(0)`).addClass('opened');
            }
        });
    }
    if ($(window).width() < 577) {
        slideMenuItems('.products__tab');
    }

    if ($(window).width() < 993) {
        slideMenuItems('.aside__list-link');
    }

    $('.order__item-arrow').on('click', function() {
        if ($(this).closest('.order__item').hasClass('closed')) {
            $(this).closest('.order__item').find('.order__item-inner').slideDown();
            $(this).closest('.order__item').removeClass('closed');
        } else {
            $(this).closest('.order__item').find('.order__item-inner').slideUp();
            $(this).closest('.order__item').addClass('closed');
        }
    });
});